import { VImg } from 'vuetify/lib/components/VImg';
import { VListItemAvatar } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VListItemAvatar,{class:[_vm.noShadow ? null : 'shadow-grey', _vm.margin, _vm.getStatus.color],staticStyle:{"overflow":"visible"},attrs:{"size":_vm.size}},[_c(VImg,{class:_vm.getStatus.shadow,attrs:{"src":_vm.getStatus.image}})],1)],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }